export default "/_next/static/media/listing-category.6d67db99bc43deea6ba5d631cca78238.png";